import Utils from '../mixins/UtilsMixin';

export default {
    mixins: [Utils],

    props: {

        defaultQueryParams: {
            type: Object,
            default: () => {},
        },

        constantQueryParams: { },

        url: {
            type: String,
            default: '',
        },

        title: {
            type: String,
            default: 'Graph :',
        },

        cardTitle: {
            type: String,
            default: 'Collected Data',
        },

        autoload: {
            type: Boolean,
            default: true,
        },

        storageItemName: {
            type: String,
            default: '',
        },

    },

    data() {

        return {
            queryParams: {
                datepicker: {},
                vselect: {},
                html: {},
            },
            queryParamsTransformed: [],
            displayedData: [],
            dataLoading: false,
            exportData: 1,
        };
    },

    mounted() {

        if (this.defaultQueryParams) {
            this.queryParams = this.defaultQueryParams;
        } else if (this.storageItemName !== '') {
            try {
                let params = JSON.parse(window.localStorage.getItem(this.storageItemName));

                if (params !== null) {
                    this.queryParams = params;
                }

            } catch (e) {
            }
        }

        if (this.autoload === true) {
            this.transformQueryParams();
            this.getData();
        }
    },

    methods: {
        onGetData() {
            this.transformQueryParams();
            this.$emit('data-clicked', this.queryParams);
            this.storeToLocalStorage(this.queryParams);
            this.getData();
        },

        transformQueryParams() {

            if (this.queryParams !== null) {
                this.queryParamsTransformed = Object.assign(
                    {},
                    this.transformDatePicker(),
                    this.transformVSelect(),
                    this.transformHtml()
                );
            }


        },

        transformDatePicker() {
            let transformedParams = [];

            Object.keys(this.queryParams.datepicker).forEach(key => {
                transformedParams[key] = this.toApiMonthString(this.queryParams.datepicker[key]);
            });

            return transformedParams;

        },

        transformVSelect() {
            let transformedParams = [];

            Object.keys(this.queryParams.vselect).forEach(key => {
                if (this.queryParams.vselect[key].constructor.name === 'Array') {
                    transformedParams[key] = this.queryParams.vselect[key].map(x => x.id);
                } else {
                    transformedParams[key] = this.queryParams.vselect[key].id;
                }
            });

            return transformedParams;
        },

        transformHtml() {
            let transformedParams = [];

            Object.keys(this.queryParams.html).forEach(key => {
                transformedParams[key] = this.queryParams.html[key];
            });
            return transformedParams;
        },

        getData() {
            let params = Object.assign(this.queryParamsTransformed, this.constantQueryParams);

            this.dataLoading = true;

            window.axios.get(this.url, { params })
                .then(response => {

                    this.displayedData = response.data;
                    this.roundData();

                })
                .catch(err => {
                    this.displayedData = null;

                    // need emergency routine
                })
                .then(() => {
                    this.dataLoading = false;
                });
        },

        storeToLocalStorage(data) {
            if (this.storageItemName !== '') {
                try {
                    return window.localStorage.setItem(this.storageItemName, JSON.stringify(data));
                } catch (e) {

                    return null;
                }
            }
        },

        roundData() {
            for (let dataSet of this.displayedData) {

                let count = 0;

                for (let data of dataSet.data) {

                    if (data.x) { // see if it has date ... cuz y can be null
                        data.y = this.roundTo(data.y, 2);
                    } else {
                        dataSet.data[count] = this.roundTo(data, 2);
                        count++;
                    }
                }

            }
        },

    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/ChartCardMixin.js